import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { LogoutOutlined, MenuOutlined } from "@ant-design/icons";
import {
  LoginData,
  loginUserSuccess,
  logoutUser,
  setIsMasterStore,
  setMasterStore,
  setSelectedStore,
} from "../../Redux/Action/loginAction";
import LanguageSwitcher from "../language-switcher";
import round from "../../assets/Images/roundimage.png";
import dropdown from "../../assets/Order/arrow_drop_down.svg";
import Notification from "../../assets/Notification.svg";
import { Dropdown, Menu, Button, Badge, Space, Drawer } from "antd";
import {
  DownOutlined,
  ShopOutlined,
  CheckCircleTwoTone,
  BellOutlined,
} from "@ant-design/icons";
import { getSubstores } from "../../API  Functions/ProfileFunctions";
import { toast } from "react-toastify";
import i18next from "i18next";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import moment from "moment";
import "moment/locale/ar";

const setLocale = (language) => {
  if (language === "ar") {
    moment.locale("ar");
  } else {
    moment.locale("en");
  }
};

const Navbar = ({ heading, Profile, expireDate, subStoreVersion }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const userinfo = useSelector((state) => state?.login?.user?.result);
  const isMasterStore = useSelector(
    (state) => state?.login?.user?.result?.is_master_store
  );
  const navigate = useNavigate();
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [Notificationdata, setNotificationdata] = useState([]);
  const [notificationCount, setNotificationCount] = useState(null);
  const [profileName, setprofileName] = useState("Hi User");
  const [profileImage, setprofileImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [subStores, setSubStores] = useState([]);
  const [loadingSubStores, setLoadingSubStores] = useState(false);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const selectedStore = useSelector((state) => state?.login?.selectedStore);
  const masterStore = useSelector((state) => state.login.masterStore);
  const dropdownRef = useRef(null);
  const storeReducer = useSelector((state) => state?.storeReducer);

  useEffect(() => {
    getNotificationCount();
    setLocale(i18n.language);
  }, [i18n.language, notificationDrawerOpen]);

  const getNotificationCount = async () => {
    let payload = { company_id: userinfo?.company_id };
    const response = await axiosInstance.post(URLS.UNREAD_NOTIFICATION_COUNT, payload);
    if (response?.data?.result[0]?.status_code == 200) {
      setNotificationCount(response?.data?.result[0]?.unread_count);
    } else {
      setNotificationCount(null);
    }
  };

  const handleReadNotification = async (id) => {
    let payload = {
      company_id: userinfo?.company_id,
      mark_as_all_read: false,
      notification_id: id,
    };
    await axiosInstance.post(URLS.MARK_READ_NOTIFICATION, payload);
  };

  useEffect(() => {
    if (masterStore) return;
    const handleMasterConversion = async () => {
      try {
        if (isMasterStore) {
          let userID = userinfo?.is_retailer ? null : masterStore?.user_id;
          const res = await getSubstores(userinfo?.company_id, userID);
          if (res?.is_master_store && userinfo?.is_retailer) {
            dispatch(setMasterStore({
              store_id: userinfo.company_id,
              store_name: userinfo.company_name,
              store_email: userinfo.email,
              is_master: true,
            }));
            dispatch(setIsMasterStore(true));
            const defaultStore = {
              store_id: userinfo.company_id,
              store_name: userinfo.company_name,
              store_name_ar: userinfo.company_name_ar,
              store_email: userinfo.email,
            };
            dispatch(setSelectedStore(defaultStore));
            localStorage.setItem("selectedSubstore", JSON.stringify(defaultStore));
          }
        }
      } catch (err) {
        console.error("Error converting to master store:", err);
      }
    };
    handleMasterConversion();
  }, [isMasterStore]);

  useEffect(() => {
    if (!userinfo) return;
    if (userinfo?.is_master_store || storeReducer) {
      fetchSubStores();
    } else {
      const defaultStore = {
        store_id: userinfo.company_id,
        store_name: userinfo.company_name,
        store_name_ar: userinfo.company_name_ar,
        store_email: userinfo.email,
      };
      dispatch(setSelectedStore(defaultStore));
      localStorage.setItem("selectedSubstore", JSON.stringify(defaultStore));
    }
  }, [subStoreVersion, userinfo, i18n.language]);

  const fetchSubStores = async () => {
    if (!masterStore) return;
    setLoadingSubStores(true);
    try {
      let userID = masterStore?.user_id;
      const res = await getSubstores(masterStore.store_id, userID);
      const substoresList = res?.response || [];
      const fullStoreList = [
        masterStore,
        ...substoresList.filter((s) => s.store_id !== masterStore.store_id && s.active === true),
      ];
      setSubStores(fullStoreList);
    } catch (err) {
      console.error("Error fetching substores", err);
    } finally {
      setLoadingSubStores(false);
    }
  };

  const handleStoreSelect = async (store) => {
    if (store.is_select_all_store) {
      try {
        const payload = { user_name: masterStore?.store_email };
        const response = await dispatch(LoginData(payload));
        if (response?.result?.status_code === 200) {
          const updatedLoginData = { ...response, result: { ...response.result, is_master_store: true } };
          dispatch(loginUserSuccess(updatedLoginData));
          const allStoreData = {
            store_id: masterStore?.store_id,
            is_select_all_store: true,
            store_name: "All Stores",
            store_name_ar: "جميع المتاجر",
          };
          dispatch(setSelectedStore(allStoreData));
          localStorage.setItem("selectedSubstore", JSON.stringify(allStoreData));
          await fetchSubStores();
          toast.success(t("Switched to All Stores"));
          navigate("/dashboard", { state: { reload: Date.now() } });
        }
      } catch (err) {
        toast.error("Error switching to All Stores");
      }
      return;
    }

    if (selectedStore?.store_id === store.store_id && !selectedStore?.is_select_all_store) return;

    try {
      const payload = { user_name: store.store_email };
      const response = await dispatch(LoginData(payload));
      if (response?.result?.status_code === 200) {
        const updatedLoginData = { ...response, result: { ...response.result, is_master_store: true } };
        dispatch(loginUserSuccess(updatedLoginData));
        dispatch(setSelectedStore({ ...store, is_select_all_store: false }));
        localStorage.setItem("selectedSubstore", JSON.stringify({ ...store, is_select_all_store: false }));
        toast.success(`${t("Switched to")} ${i18next.language === "ar" ? store.store_name_ar : store.store_name}`);
        navigate("/dashboard", { state: { reload: Date.now() } });
      }
    } catch (err) {
      toast.error("Error switching store");
    }
  };

  const openNotificationDrawer = async () => {
    setNotificationDrawerOpen(true);
    await getorderNotifications();
  };

  const closeNotificationDrawer = () => setNotificationDrawerOpen(false);

  const storeMenu = (
    <Menu>
      <Menu.Item disabled>
        <Space><ShopOutlined /><span>{t("Select Store or Warehouse")}</span></Space>
      </Menu.Item>
      <Menu.Divider />
      {masterStore && (
        <Menu.Item key="all_stores" onClick={() => handleStoreSelect({ is_select_all_store: true, store_id: masterStore.store_id, store_name: "All Stores", store_name_ar: "جميع المتاجر" })}>
          <div className="flex justify-between items-center">
            <div className="me-4">{t("All Stores")}</div>
            {selectedStore?.is_select_all_store && <CheckCircleTwoTone twoToneColor="#52c41a" />}
          </div>
        </Menu.Item>
      )}
      {subStores.map((store) => (
        <Menu.Item key={store.store_id} onClick={() => handleStoreSelect(store)} className={`${masterStore?.store_id == store.store_id ? "bg-blue-100" : ""}`}>
          <div className="flex justify-between items-center">
            <div className="me-4">{i18n.language === "ar" ? store?.store_name_ar : store?.store_name}</div>
            {selectedStore?.store_id === store.store_id && !selectedStore?.is_select_all_store && <CheckCircleTwoTone twoToneColor="#52c41a" />}
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );

  const handleToggleDropdown = () => setDropdownVisible((prev) => !prev);

  const handleLogout = () => {
    const currentLang = localStorage.getItem("selectedLanguage");
    localStorage.clear();
    dispatch(logoutUser());
    localStorage.setItem("selectedLanguage", currentLang);
    navigate("/login");
  };

  const getorderNotifications = async () => {
    let payload = {
      company_id: userinfo?.company_id,
      limit: 20,
      offset: 0,
      lang: i18n.language == "ar" ? "ar_001" : "en_US",
    };
    const response = await axiosInstance.post(URLS.NOTIFICATIONS, payload);
    if (response?.data?.result[0]?.status_code == 200) {
      setNotificationdata(response?.data?.result[0]?.data);
    } else {
      setNotificationdata([]);
    }
  };

  useEffect(() => {
    if (userinfo) {
      const companyName = userinfo?.company_name ?? "Hi User";
      setprofileName(companyName.split(" ")[0]);
      setprofileImage(userinfo?.image_url || round);
    }
  }, [userinfo]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setDropdownVisible(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div className="flex flex-col md:flex-row items-center z-10 justify-between w-full shadow-sm bg-white py-2 md:py-[7px] px-2 md:px-1 top-0 right-0">
        
        {/* --- TOP ROW (Mobile) / LEFT SECTION (Web) --- */}
        <div className="flex items-center justify-between w-[86%] md:w-auto ms-16 md:ms-0 mt-1 md:mt-0 ">
          <h2 className={`text-md md:text-xl font-semibold md:ml-[3vh] md:mr-[3vh] text-start md:text-center`}>
            {t(heading)}
          </h2>

          {/* Action Group (Mobile Icons) */}
          <div className="flex items-center md:hidden gap-0 md:gap-1">
             <Badge count={notificationCount} size="small">
                <Button
                  type="text"
                  icon={<BellOutlined style={{ fontSize: "20px" }} />}
                  onClick={openNotificationDrawer}
                />
             </Badge>
             <LanguageSwitcher setLoading={setLoading} loading={loading} />
          </div>
        </div>

        {/* --- BOTTOM ROW (Mobile) / RIGHT SECTION (Web) --- */}
        <div className="flex items-center w-full md:w-auto flex-wrap justify-between md:justify-end mt-4 md:mt-0">
          
          {/* Store Selector (Full width on Mobile) */}
          <div className="w-[55%] md:w-auto md:me-5">
            {(userinfo?.is_master_store || userinfo?.master_store_id) && (
              <Dropdown overlay={storeMenu} trigger={["click"]}>
                <Button 
                  className="w-full md:w-auto flex justify-between items-center h-10 rounded-xl"
                  icon={<ShopOutlined />} 
                  loading={loadingSubStores}
                >
                  <Space className="truncate max-w-[120px] md:max-w-none">
                    {(i18n.language === "ar"
                      ? selectedStore?.store_name_ar
                      : selectedStore?.store_name) || "Select Store"}
                    <DownOutlined className="text-[10px]" />
                  </Space>
                </Button>
              </Dropdown>
            )}
          </div>

          {/* Desktop Only Elements (Moved to Row 1 on Mobile) */}
          <div className="hidden md:flex items-center">
             <LanguageSwitcher setLoading={setLoading} loading={loading} />
             <div className="ms-4">
                <Badge count={notificationCount} size="small" offset={[-5, 5]}>
                  <Button
                    type="text"
                    icon={<BellOutlined style={{ fontSize: "20px" }} />}
                    onClick={openNotificationDrawer}
                  />
                </Badge>
             </div>
          </div>

          {/* Profile Dropdown */}
          <div className="relative ms-auto md:mx-4" ref={dropdownRef}>
            <button
              className="p-2 ps-1 w-32 md:w-40 h-10 bg-none rounded-3xl border border-[#E3E7EF] cursor-pointer flex items-center"
              onClick={handleToggleDropdown}
            >
              <img
                className="me-2 h-7 w-7 md:h-8 md:w-8 object-cover rounded-full"
                src={profileImage}
                alt="Profile"
              />
              <p className="font-medium text-xs md:text-sm truncate">
                {profileName}
              </p>
              <DownOutlined className="ms-auto text-[10px] text-gray-400" />
            </button>
            {isDropdownVisible && (
              <div className="absolute w-full top-full mt-1 bg-white border rounded-lg shadow z-50">
                <div className="p-3 cursor-pointer text-sm" onClick={handleLogout}>
                  <LogoutOutlined /> {t("logout")}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Trial Expire Alert */}
        {expireDate && (
          <div className="w-full mt-2 md:hidden">
            <div className="px-3 py-1 text-center text-[10px] font-semibold text-[#B08D15] border border-yellow-200 rounded-lg bg-yellow-50">
              {t("Free Trial Expires on: ")} {expireDate}
            </div>
          </div>
        )}

        {/* Drawers and Logic */}
        <Drawer
          title={t("Notifications")}
          placement={i18n.language == "ar" ? "left" : "right"}
          onClose={closeNotificationDrawer}
          open={notificationDrawerOpen}
          width={window.innerWidth < 768 ? "100%" : 400}
        >
          {Notificationdata?.length === 0 ? (
            <div className="flex h-full items-center justify-center">{t("No New Notifications")}</div>
          ) : (
            Notificationdata.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  if (!item.is_read) handleReadNotification(item.id);
                  closeNotificationDrawer();
                  navigate("/substore/stocktransferhistory", { state: { id: item.transfer_id, order_no: item.order_no } });
                }}
                className={`px-4 py-3 mb-2 rounded-lg border cursor-pointer ${item.is_read === false ? "bg-blue-50 border-blue-200" : "bg-white border-gray-100"}`}
              >
                <div className="flex justify-between items-center">
                  <span className="text-sm font-bold">{item.name}</span>
                  <span className="text-[10px] text-gray-400">{moment(item.create_date).fromNow()}</span>
                </div>
                <div className="text-xs text-gray-500 mt-1">{item.message} ({item.order_no})</div>
              </div>
            ))
          )}
        </Drawer>
      </div>
    </>
  );
};

export default Navbar;